import { BaseRepository } from "@/repositories/BaseRepository";
import { IActivation } from "@/models";

class DashboardRepository extends BaseRepository<IActivation> {
    constructor() {
        super("/Activations");
    }

    public getActivationByUser(UserUniqueId: string): Promise<IActivation[]> {
        const path = `/${UserUniqueId}/Activation`;

        return this.getAll({}, path);
    }

    public getPastActivationByUser(UserUniqueId: string): Promise<IActivation[]> {
        const path = `/${UserUniqueId}/PastActivation`;

        return this.getAll({}, path);
    }

    public getActivationById(Id: number): Promise<IActivation[]> {
        const path = `/${Id}`;

        return this.getAll({}, path);
    }
}

const dashboardRepository = new DashboardRepository();

export { DashboardRepository, dashboardRepository };
